// /**
//  * Add Parcels Items - list
//  */

// React
import React from 'react';

// UI

import theme from '../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
} from '@material-ui/core';

import RonadIcons from '../../../components/iconComponent';

type Data = { name: string; id: number; count: number };
type Props = {
  data: any;
  deleteItem: (body: Data) => void;
};

type Ord = 'asc' | 'desc';
interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      textAlign: 'left',
      padding: '10px 0',
      backgroundColor: '#BEC2D3 !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    body: {
      textAlign: 'left',
      padding: '10px 10px',
      borderRadius: '0',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      minWidth: 750,
    },
    columnText: {
      padding: '0 10px',
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const IconSort = (order: Ord) => {
  return (
    <RonadIcons name={order === 'asc' ? 'chevronDown' : 'chevronUp'} size={1} />
  );
};

const headCells: HeadCell[] = [
  {
    id: 'name',
    label: 'نام کالا',
  },
  {
    id: 'productCode',
    label: 'کد کالا',
  },
  {
    id: 'variantCode',
    label: 'کد تنوع کالا',
  },
  {
    id: 'variantId',
    label: 'شناسه تنوع کالا',
  },
  {
    id: 'fulfillmentVariantCode',
    label: 'کد مرکز پردازش',
  },
  {
    id: 'count',
    label: 'تعداد کالا',
  },
];

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const classes = useStyles();
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => {
          let orderStatus = orderBy === headCell.id ? order : 'asc';
          return (
            <StyledTableCell
              key={headCell.id}
              align="center"
              sortDirection={orderBy === headCell.id ? order : false}
              data-cy={headCell.id}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                IconComponent={() => IconSort(orderStatus)}
              >
                <span className={classes.columnText}>{headCell.label}</span>
              </TableSortLabel>
            </StyledTableCell>
          );
        })}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<any>('id');
  const [dense] = React.useState(false);
  const { } = props;

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data.length}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                let variantName = row.productName;
                for (
                  let i = 0;
                  row.featureAndValues && i <= 2 && row.featureAndValues[i];
                  i++
                ) {
                  variantName = variantName.concat(
                    ' - ',
                    row.featureAndValues[i].key,
                    ' : ',
                    row.featureAndValues[i].value
                  );
                }

                if (row.sellerName || row.providerName) {
                  const sellerName = row.sellerName ?? row.providerName;
                  variantName = variantName.concat(' ( ', sellerName, ' )');
                }

                return (
                  <TableRow key={index}>
                    <StyledTableCell data-cy="variantName" align="center">
                      {variantName}
                    </StyledTableCell>
                    <StyledTableCell data-cy="productCode" align="center">
                      {row.productCode}
                    </StyledTableCell>
                    <StyledTableCell data-cy="variantCode" align="center">
                      {row.variantCode}
                    </StyledTableCell>
                    <StyledTableCell data-cy="variantId" align="center">
                      {row.variantId}
                    </StyledTableCell>
                    <StyledTableCell
                      data-cy="fulfillmentVariantCode"
                      align="center"
                    >
                      {row.fulfillmentVariantCode ?? '---'}
                    </StyledTableCell>
                    <StyledTableCell
                      component="th"
                      id={labelId}
                      scope="row"
                      align="center"
                    >
                      {row.amount}
                    </StyledTableCell>

                    <StyledTableCell align="right">
                      <IconButton
                        aria-label="cancele"
                        title="حذف آیتم "
                        size="small"
                        onClick={() => props.deleteItem(row)}
                        data-cy="removeItem"
                      >
                        <RonadIcons name="times"  size={0.8} className="text-danger"/>
                      </IconButton>
                    </StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
